const textInputWithFlags = {
    tooltipText: 'translations: '
};

export default textInputWithFlags;